import { enhancedApiClient, ApiResponse } from "../../../services/enhancedApiClient";
import type { LeadStageMaster } from "../types";

class LeadStageMasterService {
    /**
     * Fetch all active lead stages (ordered by stage_order)
     */
    async getStages(includeInactive = false): Promise<ApiResponse<LeadStageMaster[]>> {
        const params: Record<string, string> = {};
        if (includeInactive) params.includeInactive = 'true';

        return await enhancedApiClient.get("/lead-stages", {
            params,
            context: "Get Lead Stages",
            component: "LeadStageMasterService"
        });
    }

    /**
     * Get a single stage by ID
     */
    async getStage(id: string): Promise<ApiResponse<LeadStageMaster>> {
        return await enhancedApiClient.get(`/lead-stages/${id}`, {
            context: "Get Lead Stage",
            component: "LeadStageMasterService"
        });
    }

    /**
     * Create a new stage
     */
    async createStage(data: Partial<LeadStageMaster>): Promise<ApiResponse<LeadStageMaster>> {
        return await enhancedApiClient.post("/lead-stages", data, {
            context: "Create Lead Stage",
            component: "LeadStageMasterService"
        });
    }

    /**
     * Update a stage
     */
    async updateStage(id: string, data: Partial<LeadStageMaster>): Promise<ApiResponse<LeadStageMaster>> {
        return await enhancedApiClient.put(`/lead-stages/${id}`, data, {
            context: "Update Lead Stage",
            component: "LeadStageMasterService"
        });
    }

    /**
     * Reorder stages
     */
    async reorderStages(stages: Array<{ id: string; stageOrder: number }>): Promise<ApiResponse<LeadStageMaster[]>> {
        return await enhancedApiClient.put("/lead-stages/reorder/batch", { stages }, {
            context: "Reorder Lead Stages",
            component: "LeadStageMasterService"
        });
    }

    /**
     * Delete (deactivate) a stage
     */
    async deleteStage(id: string): Promise<ApiResponse<{ deactivated: boolean; leadsUsing?: number }>> {
        return await enhancedApiClient.delete(`/lead-stages/${id}`, {
            context: "Delete Lead Stage",
            component: "LeadStageMasterService"
        });
    }
}

export const leadStageMasterService = new LeadStageMasterService();
